/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports.cogs
 * @name ReportsCogsPosItemLinksCtrl
 */
angular.module('mercury.modules.reports.cogs')
.controller('ReportsCogsPosItemLinksCtrl', ["dialog", "reporttime", "$scope", "dialogData", "ReportsCogsPosItemLinkService", "ReportSales", "StockPosItemLinks", "StockItems", "StockRecipes", "StockUnits", "$q", function(dialog, reporttime, $scope, dialogData,
  ReportsCogsPosItemLinkService, ReportSales, StockPosItemLinks, StockItems, StockRecipes, StockUnits, $q) {
  var service = ReportsCogsPosItemLinkService;
  service.clearAll();

  $scope.stockCostTooltip = `The stock cost of the active link may vary from the products report as the stock cost (in this pop up) is 
    calculated at the end of the reporting period. Thus if stock has been recieved during the reporting period with a 
		different cost a product can have a varying stock cost.`

  $scope.posItemLines = service.posItemLines;
  $scope.posItemName = dialogData.posItemName;
  $scope.startDate = reporttime.start();
  $scope.endDate = reporttime.end();

  // returns the previous non-deleted posLink in the list (if any)
  function getPreviousPosLinkIndex(index) {
    for (var i = index - 1; i >= 0; i--) {
      if (!$scope.posItemLines[i].deleted) {
        return i;
      }
    }
    return null;
  }

  // returns the previous non-deleted posLink in the list (if any)
  function getPreviousPosLink(index) {
    var previousIndex = getPreviousPosLinkIndex(index);
    if (previousIndex !== null) {
      return $scope.posItemLines[previousIndex];
    } else {
      return null;
    }
  }

  // returns the index of the next non-deleted posLink in the list (if any)
  $scope.getNextPosLinkIndex = function(index) {
    for (var i = index + 1; i < $scope.posItemLines.length; i++) {
      if (!$scope.posItemLines[i].deleted) {
        return i;
      }
    }
    return null;
  };

  // returns the next non-deleted posLink in the list (if any)
  function getNextPosLink(index) {
    var nextIndex = $scope.getNextPosLinkIndex(index);
    if (nextIndex !== null) {
      return $scope.posItemLines[nextIndex];
    } else {
      return null;
    }
  }

  $scope.loading = $q.all({
    posLinks: StockPosItemLinks.getAllPosItemLinksForItem(dialogData.posItemId),
    posSales: ReportSales.getByDay(reporttime.start(), reporttime.end(), dialogData.posItemId),
    allRecipes: StockRecipes.getAllStockApi().$promise,
    allStockItems: StockItems.getAllStockApi().$promise,
    allUnits: StockUnits.getAllStockApi().$promise
  });

  $scope.loading.then(function(results) {
    service.posSales = results.posSales;
    service.allRecipes = results.allRecipes;
    service.allStockItems = results.allStockItems;
    $scope.allPosLinks = results.posLinks;
    $scope.allUnits = results.allUnits;

    $scope.allPosLinks.forEach(function(posItemLink, index) {
      $scope.posItemLines.push(service.makeLink(posItemLink, index));
    });

    // This is to display the spinners on initial load of the dialog  
    $scope.intialCogsPromiseResolved = false;

    service.calculateCogsForLinks($scope.posItemLines, reporttime.start(), reporttime.end())
    .then(function() { $scope.intialCogsPromiseResolved = true })

    $scope.linkOptions = [];

    angular.forEach(service.allStockItems, function(item) {
      $scope.linkOptions.push({
        name: item.name,
        id: item.id,
        group: item.groupName,
        unitId: item.countingUnitId,
        unitName: item.countingUnitName,
        unitRatio: item.countingUnitRatio,
        currentPrice: item.currentPrice
      });
    });

    angular.forEach(service.allRecipes, function(recipe) {
      $scope.linkOptions.push({
        name: recipe.name,
        id: recipe.id,
        group: 'Recipes',
        unitId: recipe.currentVersionYeildUnitId,
        unitName: recipe.currentVersionYeildUnitName,
        unitRatio: recipe.currentVersionYeildUnitRatio,
        currentPrice: recipe.currentPrice
      });
    });
  });

  $scope.isInReportPeriod = function(link) {
    var nextLine = getNextPosLink(link.lineIndex);
    return (link.validFrom == null || moment(link.validFrom).isBefore(moment(reporttime.end()))) &&
      (!nextLine || moment(nextLine.validFrom).isAfter(moment(reporttime.start())));
  };

  /**
    * Event handler for when the user clicks on the Stock Cost link to open the supporting dialog
    *
    * @memberof ReportsCogsPosItemLinkService
    * @param {Object} posItemLine line for which the link was clicked
    */
  $scope.openCostLink = function(posItemLine) {
    var templateUrl;
    var controller;

    if (posItemLine.recipeId) {
      templateUrl = 'modules/stock/recipe/viewdialog.tpl.html';
      controller = 'StockRecipeViewDialogCtrl';
    } else {
      templateUrl = 'modules/reports/cogs/purchasehistory.tpl.html';
      controller = 'CogsPurchaseHistoryCtrl';
    }

    dialog.open({
      backdrop: 'static',
      templateUrl: templateUrl,
      controller: controller,
      size: 'lg',
      resolve: {
        dialogData: function() {
          return {
            recipeId: posItemLine.recipeId,
            stockItemId: posItemLine.stockItemId,
            startDate: reporttime.start(),
            endDate: reporttime.end(),
            cogsStockCostPurchaseOrderId: posItemLine.stockCostPurchaseOrderId
          };
        }
      }
    }).then(function(dialogResult) {
      if (dialogResult && dialogResult.recipeChanged === true) {
        $scope.cogsChanged = true;
      }
    });
  };

  /**
    * Event handler for when the user selects a stock item or recipe from the item autocomplete directive.
    *
    * @memberof ReportsCogsPosItemLinkService
    * @param {Object} link line for which the link was clicked
    * @param {Object} newStockitem item information returned from the autocomplete directive
    */
  $scope.linkItemSet = function(link, newStockitem) {
    link.stockDeleted = false;
    link.stockName = newStockitem.name;

    if (newStockitem.group == 'Recipes') {
      link.recipeId = newStockitem.id;
      link.stockItemId = null;
    } else {
      link.recipeId = null;
      link.stockItemId = newStockitem.id;
    }

    if (!link.unitRatio) {
      link.unitId = newStockitem.unitId;
      link.unitName = newStockitem.unitName;
      link.unitRatio = newStockitem.unitRatio;
    }

    if (!link.quantity) {
      link.quantity = 1;
    }

    service.calculateCogsForLink(link, reporttime.start(), reporttime.end());

    link.pending = true;
  };

  $scope.linkItemAdd = function(item, newStockitem) {
    var previousItem = $scope.posItemLines[$scope.posItemLines.length - 1];

    $scope.posItemLines.push({
      lineIndex: $scope.posItemLines.length,
      posIdentifier: dialogData.posItemId,
      validFrom: moment().mStartOf('day').toDate()
    });

    if (previousItem) {
      service.calculateCogsForLink(previousItem, reporttime.start(), reporttime.end());
    }

    $scope.linkItemSet($scope.posItemLines[$scope.posItemLines.length - 1], newStockitem);

    // Cascade the change to the Valid dates if we need to.
    $scope.linkValidFromSet($scope.posItemLines.length - 1, null, false);
  };

  $scope.linkUnitSet = function(link, newUnit) {
    link.quantity = (link.quantity / link.unitRatio) * newUnit.ratio;
    link.unitRatio = newUnit.ratio;
    service.calculateCogsForLink(link, reporttime.start(), reporttime.end());
    link.pending = (link.recipeId !== null || link.stockItemId !== null) && link.unitId !== null;
  };

  $scope.linkQuantitySet = function(link) {
    link.pending = (link.recipeId !== null || link.stockItemId !== null) && link.unitId !== null;
    service.calculateCogsForLink(link, reporttime.start(), reporttime.end());
  };

  function cascadeUpdate(newValidFrom, cascadeIndex, direction) {
    $scope.posItemLines[cascadeIndex].validFrom = moment(newValidFrom).add(direction, 'days').format();
    $scope.linkValidFromSet(cascadeIndex, direction);
  }

  /**
   * Triggered when the user updates the ValidFrom field in a PosItemLine
   */
  $scope.linkValidFromSet = function(index, direction) {
    var link = $scope.posItemLines[index];

    // load new cogs
    service.calculateCogsForLink(link, reporttime.start(), reporttime.end());
    link.pending = true;

    // if the valid from has been set to a value less than the valid
    // from of the previous link, then we need to cascade the change
    var previousPosLink = getPreviousPosLink(index);
    var currentLink = $scope.posItemLines[index];
    var nextPosLink = getNextPosLink(index);

    var previousLinkHasValidFromDate = previousPosLink && moment(previousPosLink.validFrom).isValid();
    var currentLinkIsNotDeleted = !$scope.posItemLines[index].deleted;
    var currentLinkValidFromEncroachesOnPreviousLink = previousLinkHasValidFromDate && moment(currentLink.validFrom).add(-1, 'days').isBefore(previousPosLink.validFrom);
    var currentLinkIsNotFirstLink = index > 0;
    var currentLinkIsNotLastLink = ($scope.getNextPosLinkIndex(index) !== null);
    var currentLinkValidFromEncroachesOnNextLink = currentLinkIsNotLastLink && moment(currentLink.validFrom).add(1, 'days').isAfter(nextPosLink.validFrom);

    // Cascade backwards
    if (currentLinkIsNotFirstLink && currentLinkIsNotDeleted && currentLinkValidFromEncroachesOnPreviousLink) {
      cascadeUpdate(moment($scope.posItemLines[index].validFrom).format(), getPreviousPosLinkIndex(index), -1);
    } else if (currentLinkValidFromEncroachesOnNextLink) {
      // if this is our first iteration through this recursion, and we're cascading forward in time, then update the cogs in the previous lineIndex
      if (!direction && previousPosLink) {
        service.calculateCogsForLink(previousPosLink, reporttime.start(), reporttime.end());
        previousPosLink.pending = true;
      }
      cascadeUpdate(moment($scope.posItemLines[index].validFrom).format(), $scope.getNextPosLinkIndex(index), 1);
    } else {
      // if we're cascading back in time and have reached the end of the cascade, or if we're not cascading at all, then
      // update the cogs on the previous line
      if (previousPosLink && (!direction || direction < 0)) {
        service.calculateCogsForLink(previousPosLink, reporttime.start(), reporttime.end());
        previousPosLink.pending = true;
      }
    }

    // Ensure that the first link in the list always has a null ValidFromDate
    var firstLinkIndex = $scope.getNextPosLinkIndex(-1);
    if (firstLinkIndex != null) {
      $scope.posItemLines[firstLinkIndex].validFrom = null;
    }
  };

  $scope.isFirstLink = function(index) {
    // we're the first link if there are no links with lower index, or if all
    // links with a lower index are deleted
    for (var i = index - 1; i >= 0; i--) {
      if (!$scope.posItemLines[i].deleted) {
        return false;
      }
    }
    return true;
  };

  $scope.isLastLink = function(index) {
    // we're the last link if there are no links with a higher index, or if all
    // links with a higher index are deleted
    for (var i = index + 1; i < $scope.posItemLines.length; i++) {
      if (!$scope.posItemLines[i].deleted) {
        return false;
      }
    }
    return true;
  };

  $scope.promiseIsPending = function(promise) {
    return promise && promise.$$state.status == 0;
  };

  $scope.allPromisesFinished = function(array, attributeName) {
    for (var i = 0; i < array.length; i++) {
      if ($scope.promiseIsPending(array[i][attributeName])) {
        return false;
      }
    }
    return true;
  };

  $scope.save = function() {
    var savingPromises = [];
    $scope.posItemLines.forEach(function(link) {
      savingPromises.push(StockPosItemLinks.savePosItemLink(link));
    });
    $scope.savingAll = $q.all(savingPromises);
    $scope.savingAll.then(function() {
      dialog.close({cogsChanged: true});
    });
  };

  $scope.cancel = function() {
    dialog.close({cogsChanged: $scope.cogsChanged});
  };

  $scope.delete = function(link) {
    link.deleted = true;
    $scope.linkValidFromSet(link.lineIndex);
  };
}]);
